import useUsersModel from "./usersPageModel";
import UserList from "./_cmp/UserList";
import UserListSkeleton from "./_cmp/UserListSkeleton";
import UsersToolbar from "./_cmp/UsersToolbar";
import { InviteUserDialog } from "./_cmp/userForm/InviteUserDialog";
import { useSessionAuth } from "@/app/_utils/sessionClient";

export default function AdminSettingsUsers() {
  const model = useUsersModel();
  const { session } = useSessionAuth();

  return (
    <div className="flex min-h-0 w-full flex-1 flex-col">
      <UsersToolbar
        search={model.search}
        onSearchChange={model.setSearch}
        statusFilter={model.statusFilter}
        onStatusChange={model.setStatusFilter}
        onInvite={() => {
          model.setEditing(null);
          model.setInviteOpen(true);
        }}
      />

      <div className="-mx-3 flex min-h-0 flex-1 flex-col md:mx-0">
        {model.isLoading ? (
          <UserListSkeleton />
        ) : (
          <UserList
            users={model.users}
            currentUserId={session?.user?.id}
            onEdit={(user) => {
              model.setEditing(user);
              model.setInviteOpen(true);
            }}
            onResend={model.resendInvite}
            onSuspend={model.suspendUser}
            onReactivate={model.reactivateUser}
            onDelete={model.deleteUser}
          />
        )}
      </div>

      <InviteUserDialog
        open={model.inviteOpen}
        editingUser={model.editing}
        roles={model.roles}
        onClose={() => {
          model.setInviteOpen(false);
          model.setEditing(null);
        }}
        onSaved={model.reload}
      />
    </div>
  );
}
